export default __webpack_public_path__ + "static/media/g2022-6.80b0755a.jpeg";